import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';
import { MsalGuard } from '@azure/msal-angular';
import { AuthGuard } from './shared/guard/auth-guard';
import { HomeComponent } from './pages/Home/home.component';
import { CabinasComponent } from './pages/Cabinas/cabinas.component';
import { ChassisComponent } from './pages/Chassis/chassis.component';
import { KDComponent } from './pages/KD/kd.component';
import { LCBExpedicaoComponent } from './pages/LCB_Expedicao/lcb-expedicao.component';
import { LCBRecebimentoComponent } from './pages/LCB_Recebimento/lcb-recebimento.component';
import { FilasComponent } from './pages/Filas/filas.component';
import { TripDetailsComponent } from './pages/Chassis/trip-details/trip-details.component';
import { TripDetailsKdComponent } from './pages/KD/trip-details-kd/trip-details-kd.component';
import { ViewExpComponent } from './pages/LCB_Expedicao/view-exp/view-exp.component';
import { ViewChassisComponent } from './pages/Chassis/view-chassis/view-chassis.component';
import { ViewKDComponent } from './pages/KD/view-kd/view-kd.component';
import { LCBEmbalagensComponent } from './pages/LCB_Embalagens/lcb-embalagens.component';
import { TripDetailsEmbalagensComponent } from './pages/LCB_Embalagens/trip-details-embalagens/trip-details-embalagens.component';
import { ViewEmbComponent } from './pages/LCB_Embalagens/view-emb/view-emb.component';
import { TripDetailsRecComponent } from './pages/LCB_Recebimento/trip-details-rec/trip-details-rec.component';
import { ViewRecComponent } from './pages/LCB_Recebimento/view-rec/view-rec.component';
import { FiscoTableComponent } from './components/fisco-table/fisco-table.component';
import { MotoresTransmissaoComponent } from './pages/Motores_Transmissao/motores-transmissao.component';
import { TripDetailsMotoresTransmissaoComponent } from './pages/Motores_Transmissao/trip-detais-motores-transmissao/trip-detais-motores-transmissao.component';
import { ViewMotoresTransmissaoComponent } from './pages/Motores_Transmissao/view-motores-transmissao/view-motores-transmissao.component';


const routes: Routes = [
  {
    path: 'Home',
    component: HomeComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'Cabinas',
    component: CabinasComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'Chassis',
    component: ChassisComponent,
    canActivate: [MsalGuard],
    children: [
      { path: 'dock/:id', component: TripDetailsComponent }
    ]
  },
  {
    path: 'KD',
    component: KDComponent,
    canActivate: [MsalGuard],
    children: [
      { path: 'dock/:id', component: TripDetailsKdComponent }
    ]
  },
  {
    path: 'LCBExpedicao',
    component: LCBExpedicaoComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'LCBExpedicao/filas',
    component: FilasComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'LCBRecebimento',
    component: LCBRecebimentoComponent,
    canActivate: [MsalGuard],
    children: [
      { path: 'dock/:id', component: TripDetailsRecComponent }
    ]
  },
  {
    path: 'LCBEmbalagens',
    component: LCBEmbalagensComponent,
    canActivate: [MsalGuard],
    children: [
      { path: 'dock/:id', component: TripDetailsEmbalagensComponent }
    ]
  },
  {
    path: 'MotoresTransmissao',
    component: MotoresTransmissaoComponent,
    canActivate: [MsalGuard],
    children: [
      { path: 'dock/:id', component: TripDetailsMotoresTransmissaoComponent }
    ]
  },
  {
    path: 'FISCO',
    component: FiscoTableComponent,
    canActivate: [MsalGuard],
  },
  /* --------------------------------------- ABAIXO APENAS VIEWS (não requerem autenticação) --------------------------------------- */
  {
    path: 'view/exp',
    component: ViewExpComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'view/rec',
    component: ViewRecComponent,
    canActivate: [AuthGuard], 
    children: [
      { path: 'dock/:id', component: TripDetailsRecComponent }
    ]
  },
  {
    path: 'view/chassis',
    component: ViewChassisComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dock/:id', component: TripDetailsComponent }
    ]
  },
  {
    path: 'view/KD',
    component: ViewKDComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dock/:id', component: TripDetailsKdComponent }
    ]
  },
  {
    path: 'view/emb',
    component: ViewEmbComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dock/:id', component: TripDetailsEmbalagensComponent }
    ]
  },
    {
    path: 'view/motores-transmissao',
    component: ViewMotoresTransmissaoComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dock/:id', component: TripDetailsMotoresTransmissaoComponent }
    ]
  },
  { path: '**', component: HomeComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // Don't perform initial navigation in iframes or popups
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
          ? 'enabledNonBlocking'
          : 'disabled', // Set to enabledBlocking to use Angular Universal
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
